<template>
  <v-container
    class="fill-height"
    fluid
  >
    <v-row
      align="center"
      justify="center"
    >
      <v-col
        cols="12"
        sm="8"
        md="4"
      >
        <v-card class="elevation-12">
          <v-card-text >
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
            >
              <PincodeInput
                v-model="pincodeEntry"
                placeholder="0"
              />
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-spacer/>
            <v-btn
              color="primary"
              @click="pincodeEnter()"
              :disabled="pincodeEntry.length < 4"
            >
              <span :class="[{'white--text': valid}]">Enter</span>
            </v-btn>
          </v-card-actions>
          <v-card-actions>
            <v-btn
              text
              color="blue"
              @click.once="showMessage = true; openResetDialog()">Forgot Pin?</v-btn>
            <v-spacer/>
          </v-card-actions>
        </v-card>
        <div v-if="showMessage === true">
          <v-alert
            type="success"
          >
            <strong>Your new pincode has been emailed to you.</strong>
          </v-alert>
        </div>
        <div v-if="showAlert === true">
          <v-alert
            type="error"
          >
            <strong>Incorrect Pincode: please try again</strong>
          </v-alert>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
import PincodeInput from 'vue-pincode-input'

export default {
  components: { PincodeInput },
  data: () => ({
    valid: false,
    errorMsg: '',
    showMessage: false,
    showPassword: false,
    showAlert: false,
    infoButton: false,
    pincodeEntry: '',
    pincodeRules: [
      v => !!v || 'Pin code is required',
      v => (v && v.length === 4) || 'This field only accepts 4 digit pincode',
      v => /^\d+$/.test(v) || 'This field only accept numbers'
    ]
  }),
  computed: {
    ...mapState(['Dbasename', 'userId', 'currentDialogTitle'])
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.$store.commit('toggle_dialog', true)
    })
  },
  methods: {
    pincodeEnter: async function () {
      if (this.$refs.form.validate()) {
        try {
          let apppincode = btoa(btoa(this.pincodeEntry))
          let userId = this.userId
          var data = { apppincode, userId }

          const resp = await this.$http.post('/checkPinCodeV2/' + this.Dbasename, data)

          if (resp.data.response === 'success') {
            sessionStorage.removeItem('locked')
            // await this.$store.dispatch('fetchPin', userId)

            window.dispatchEvent(new Event('app-unlocked'))
            this.$router.push('/home')
            location.reload()
          } else {
            this.apppincode = ''
            this.showAlert = true
            setTimeout(() => {
              location.reload()
            }, 1000)
          }
        } catch (error) {
          console.error(error)
        }
      }
    },
    openResetDialog: async function () {
      this.$store.commit('toggle_dialog', true)
      try {
        const resp = await this.$http.post('/sendPinCodeV2/' + this.Dbasename, {
          userId: this.userId
        })

        if (resp.data.response === 'success') {
          this.showMessage = true
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>
